import {useCallback} from '@wordpress/element';
import {useDispatch} from '@wordpress/data';
import {CART_STORE_KEY} from '@woocommerce/block-data';
import {STORE_KEY} from '@ppcp/block-data';
import {extractFullName} from '@ppcp/utils';
import {setCustomerContextId} from "../../../data/checkout/actions";

export const useManageFastlaneToken = (
    {
        fastlane
    }) => {

    const {
        setPaymentToken,
        setCustomerContextId
    } = useDispatch(STORE_KEY);

    const {
        setBillingAddress
    } = useDispatch(CART_STORE_KEY);

    const {
        createErrorNotice
    } = useDispatch('core/notices');

    const onCancel = useCallback(() => {
        setPaymentToken(null);
        setCustomerContextId(null);
    }, []);

    const onChangePaymentMethod = useCallback(async () => {
        try {
            const {
                selectedCard,
                selectionChanged
            } = await fastlane.profile.showCardSelector();

            if (selectedCard && selectionChanged) {
                setPaymentToken(selectedCard);

                if (selectedCard?.paymentSource?.card?.billingAddress) {
                    const {
                        name = '',
                        billingAddress
                    } = selectedCard.paymentSource.card;
                    const address = billingAddress;
                    const fullName = extractFullName(name);
                    setBillingAddress({
                        first_name: fullName[0],
                        last_name: fullName[1],
                        address_1: address?.addressLine1,
                        address_2: address?.addressLine2,
                        city: address?.adminArea2 || '',
                        state: address?.adminArea1 || '',
                        postcode: address?.postalCode || '',
                        country: address?.countryCode || '',
                    });
                }
            }
        } catch (error) {
            createErrorNotice(error.message, {
                id: 'wc-ppcp-tokenize-error',
                context: 'wc/checkout/payments'
            });
        }
    }, [fastlane]);

    return {
        onCancel,
        onChangePaymentMethod
    }

}